import { useEffect, useState } from "react";

// คืนค่า true เมื่อจอแคบกว่า breakpoint (ค่าเริ่มต้น 767.98px = ต่ำกว่า md ของ bootstrap)
// ใช้กับหน้าที่ layout ต้องเปลี่ยนโครงจริง ๆ (เช่นตาราง Gantt ที่ต้องตัดคอลัมน์ทิ้ง)
// ถ้าแค่ปรับสไตล์ ให้ใช้ media query ใน style.css แทน จะเบากว่า
export default function useIsMobile(maxWidth = 767.98) {
  const query = `(max-width: ${maxWidth}px)`;

  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setIsMobile(event.matches);

    setIsMobile(mediaQuery.matches); // sync เผื่อขนาดเปลี่ยนไปแล้วก่อน effect ทำงาน
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]);

  return isMobile;
}
